import React from 'react';
import { Checkbox } from 'components/ui/checkbox';
import { Input } from 'components/ui/input';
import { IFilterConfig, IFilterConfigString } from './types';

interface IProps {
  item: IFilterConfig;
  setSelected: (arg1: string, arg2: boolean) => void;
  setValue: (arg1: string, arg2: number, arg3: string) => void;
}

const StringFilter = ({ item, setSelected, setValue }: IProps): JSX.Element => {
  const { selected, key, label, data } = item;
  const { values, placeholder } = data as IFilterConfigString;
  const value = values[0];
  const placeholderValue = placeholder;
  return (
    <>
      <div className="flex items-center gap-2 px-2 py-1">
        <Checkbox
          id={label}
          data-testid="string-checkbox"
          checked={selected}
          onCheckedChange={(checked) => setSelected(key, checked === true)}
        />
        <label htmlFor={label} className="body-subtext-regular">
          {label}
        </label>
      </div>

      {selected && (
        <div className="px-2 pb-2">
          <Input
            placeholder={placeholderValue}
            className="mb-2 w-full"
            defaultValue={value}
            onChange={(e) => {
              setValue(key, 0, e.target.value);
            }}
          />
        </div>
      )}
    </>
  );
};
export default StringFilter;
